const paginationSelector = '.clickable-banner-slider__pagination';
const homepagePromotionLabels = [
  'Mostrar promoción de belleza coreana y cuidado de la piel',
  'Mostrar promoción de maquillaje Beauty Place',
  'Mostrar promoción de productos nuevamente disponibles',
  'Mostrar promoción de 10% de ahorro en octubre',
];

/**
 * Adds an accessible name to the visual dot buttons generated by the
 * Clickable Banner Slider app. Existing labels from a future app update are
 * preserved.
 *
 * @param {ParentNode} root
 */
function labelCarouselPagination(root = document) {
  const groups = root.querySelectorAll(paginationSelector);

  for (const group of groups) {
    const buttons = Array.from(group.querySelectorAll('button'));
    const total = buttons.length;

    for (const [index, button] of buttons.entries()) {
      if (button.getAttribute('aria-label')?.trim()) continue;
      const fallbackLabel = `Mostrar imagen ${index + 1} de ${total}`;
      const label = total === homepagePromotionLabels.length
        ? homepagePromotionLabels[index]
        : fallbackLabel;
      button.setAttribute('aria-label', label);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => labelCarouselPagination(), { once: true });
} else {
  labelCarouselPagination();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) labelCarouselPagination(event.target);
});
